<script>
import BasicInput from "../../../../theme/atoms/BasicInput.vue";
import BasicButton from "../../../../theme/atoms/BasicButton.vue";
import {currentLocale} from "../../../../services/LocaleServices";
import LoginFormCandidate from "../../atoms/FormCandidate.vue";
import Button from "../../../../theme/atoms/BasicButton.vue";
import Messages from "../../atoms/Messages.vue";

export default {
    name: "LoginForm",
    props: {
        candidate: {
            type: Object,
            required: false
        },
        errors: {
            type: Array,
            required: false
        }
    },
    components: {
        Button,
        Messages,
        LoginFormCandidate,
        BasicInput,
        BasicButton,
    },
    data() {
        return {
            identifier: null,
            password: null,
            submitting: false,
            submittingForgot: false,
            loginErrors: this.errors
        }
    },
    computed: {
        termsAndConditions() {
            return `https://kidsday.com/${currentLocale()}/terms-and-conditions`;
        },
    },
    methods: {
        setCsrfToken() {
            this.$refs.csrfTokenInput.value =  document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        },
        setScreenRatio() {
            const physicalWidth = screen.width * window.devicePixelRatio;
            const physicalHeight = screen.height * window.devicePixelRatio;

            this.$refs.screenResolutionInput.value = physicalWidth + 'x' + physicalHeight;
        },
        handleSubmit() {
            this.submitting = true;
        },
        submitForgotPassword() {
            this.submittingForgot = true;
            axios.post('/auth/forgot-password', {username: this.candidate.username})
                .then(({data}) => {
                   this.$emit('forgot-password-success', data.message);
                }).catch(({response}) => {
                    this.loginErrors = response.data.errors;
                }).finally(() => {
                    this.submittingForgot = false;
                });
        }
    },
    mounted() {
        this.setCsrfToken();
        this.setScreenRatio();
    }
}
</script>

<template>
    <form class="d-flex flex-column gap-3 w-100" action="/auth/login" method="post" autocomplete="off" @submit="handleSubmit">
        <login-form-candidate :candidate="candidate" v-if="candidate"/>

        <messages v-if="loginErrors" :messages="loginErrors"/>

        <input v-if="candidate" type="hidden" name="identifier" :value="candidate.username"/>
        <basic-input v-else required autocomplete="new-identifier" name="identifier" left-icon="fi-rr-user" :label="trans('general.page.login.username')" v-model="identifier"/>

        <basic-input required autocomplete="new-password" name="password" left-icon="fi-rr-password" type="password" :label="trans('general.page.login.password')" v-model="password"/>
        <input type="hidden" name="screen_resolution" ref="screenResolutionInput">
        <input type="hidden" name="_token" ref="csrfTokenInput">

        <div class="mt-2">
            <div v-if="!candidate" class="mb-1 w-100 text-center">
                <span class="label small"> {{ trans('general.page.login.login.terms_info') }}</span>
                <a class="label small font-weight-bold" target="_blank" :href="termsAndConditions">
                     {{ trans('general.defaults.terms_and_conditions') }}
                </a>
            </div>

            <basic-button class="btn-primary btn-100" :loading="submitting" type="submit" :text="trans('general.page.login.submit')"/>
        </div>
        <a v-if="!candidate" href="/auth/forgot-password" class="forgot-password text-center">{{ trans('general.page.login.forgot') }}</a>
        <div v-else class="text-center">
            <button :disabled="submittingForgot" type="button" v-if="candidate" @click="submitForgotPassword" class="btn-link btn forgot-password">
                {{ trans('general.page.login.forgot') }}
            </button>
        </div>
    </form>
</template>

<style scoped>
.btn-100 {
    min-width: 100%;
}
</style>
